export default "__VITE_ASSET__BjgZOeG___"